<template>
    <div>
        <h2>Hast du einen Unfallbericht?</h2>
        <div class="ion-text-right ion-padding-top">
            <chat-radio-group
                v-if="isVisible"
                v-model="answer"
                :radios="radios"
            />
            <div v-show="answer === 'Ja'" class="ion-margin-top">
                Bitte lade dein Dokument hoch
                <files-upload
                    v-model="unfallbericht"
                    :multiple="false"
                    id="unfallbericht"
                    flexDirection="row-reverse"
                ></files-upload>
                <ion-button
                    class="-round -add-padding ion-margin-top"
                    :disabled="unfallbericht.length === 0"
                    @click="
                        $emit('change', [
                            {
                                id: 'hasUnfallbericht',
                                value: answer,
                            },
                            {
                                id: 'unfallbericht',
                                value: unfallbericht,
                            },
                        ])
                    "
                    >Weiter</ion-button
                >
            </div>
        </div>
    </div>
</template>

<script>
import ChatRadioGroup from "@/components/ChatRadioGroup";
import FilesUpload from "@/components/FilesUpload";

export default {
    components: { ChatRadioGroup, FilesUpload },
    props: {
        isVisible: {
            required: false,
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            radios: [{ value: "Ja" }, { value: "Nein" }],
            answer: "",
            unfallbericht: [],
        };
    },
    watch: {
        answer(value) {
            if (value === "Nein") {
                this.$emit("change", [
                    {
                        id: "hasUnfallbericht",
                        value: value,
                    },
                    {
                        id: "unfallbericht",
                        value: [],
                    },
                ]);
            }
        },
    },
};
</script>

<style lang="scss" scoped></style>
